function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.755 21.88l1.45.034 7.95-8.268-1.483-1.431-7.95 8.233.033 1.432zM8.51 19.942l8.42-8.72c.372-.384 1-.38 1.404.009l1.781 1.72c.403.39.429 1.017.057 1.402l-8.419 8.797-3.17-.074-.073-3.134z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.924 13.389l2.888 3.025.826-.865-2.888-3.025zm-3.711-10.98v3.203h3.248l-3.164-3.203h-.085zm-1.425 0H1.716a.281.281 0 00-.292.282v16.513c0 .148.134.282.289.282h4.31a.712.712 0 110 1.425h-4.31A1.718 1.718 0 010 19.204V2.691C0 1.745.763.984 1.717.984h9.877c.19 0 .373.076.507.212l3.74 3.785a.712.712 0 01.205.5v4.326a.712.712 0 01-1.425 0v-2.77H10.5a.712.712 0 01-.713-.712V2.409zM7.5 16.25a.75.75 0 110 1.5H4.017a.75.75 0 110-1.5H7.5zm3-3a.75.75 0 110 1.5H4.017a.75.75 0 110-1.5H10.5zm2-3a.75.75 0 110 1.5H4.017a.75.75 0 110-1.5H12.5z"
}));
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8123d2d7.svg";
export { ForwardRef as ReactComponent };